import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';
import { Tooltip } from 'components/Tooltip';
import styles from 'components/Table/Table.scss';

export const Table = ({ className, columns, data, renderRow, selectedIDs }) => (
  <div className={cn(styles.tableContainer, className)}>
    <table className={styles.table}>
      <thead>
        <tr>
          {columns.map(({ key, label, info }) => (
            <th key={key}>
              {info && (
                <span className={styles.infoWrapper}>
                  <FontAwesomeIcon className={styles.infoIcon} icon={faInfoCircle} />
                  <Tooltip className={styles.info} text={info} />
                </span>
              )}
              {label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr className={cn({ [styles.selected]: selectedIDs?.includes(item.id) })} key={item.id}>
            {renderRow(item, index)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
